import styled from "styled-components";

const ArticleCarouselStyles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 70px;

  .article-carousel {
    width: 92vw;
    max-width: 1030px;
    margin: 0 auto;
  }

  .article-carousel > a {
    border-radius: 30px !important;
  }

  button.carousel-arrow.carousel-left-arrow.carousel-arrow-default,
  button.carousel-arrow.carousel-right-arrow.carousel-arrow-default {
    display: none;
  }

  .carousel-dots {
    transform: translateY(14px);
    font-size: 34px;
  }

  .card {
    overflow: hidden;
    -webkit-border-radius: 30px !important;
    -moz-border-radius: 30px !important;
    border-radius: 30px !important;

    img {
      border-radius: 30px;
    }
  }

  .card-text {
    padding: 12px 12px;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    p {
      line-height: 30px;
      margin-bottom: 10px !important;
      margin-left: 0;
      max-width: 220px;
      span {
        //hack to apply background color to individual text lines
        box-shadow: 0 0 0 2px #f0fd9d;
        background-color: #f0fd9d;
        //fix firefox
        box-decoration-break: clone;
        line-height: 16px;
        padding: 0 3px 0 3px;
        border: 1px solid #f0fd9d;
      }
    }
  }

  @media (min-width: 900px) {
    .carousel {
      &-arrow {
        transform: translateY(-100px);
        z-index: 120000;
        border: none !important;
      }
    }

    .carousel-dots {
      font-size: initial;
      transform: translateY(6px);
    }

    button.carousel-arrow.carousel-left-arrow.carousel-arrow-default {
      display: block;
      border: none !important;
      background: rgba(0, 0, 0, 0.5);
      height: 50px;
      width: 50px;
      left: 6px;

      &::before {
        position: absolute !important;
        top: -27px !important;
        transform: translateY(25%);
        left: 0 !important;
        height: 50px !important;
        width: 50px !important;
        font-family: var(--body-font) !important;
        content: "‹" !important;
        font-size: 60px;
        font-weight: 100;
        color: white;
        opacity: 0.9;
      }
    }

    button.carousel-arrow.carousel-right-arrow.carousel-arrow-default {
      display: block;
      border: none !important;
      background: rgba(0, 0, 0, 0.5);
      height: 50px;
      width: 50px;
      right: 6px;

      &::before {
        font-family: var(--body-font);
        content: "›";
        position: absolute !important;
        top: -27px !important;
        transform: translateY(25%);
        left: 0 !important;
        height: 50px !important;
        width: 50px !important;
        font-size: 60px;
        font-weight: 100;
        color: white;
        opacity: 0.9;
      }
    }
  }
`;

export default ArticleCarouselStyles;
